import { useMemo } from 'react';

import { useTheme } from '@mui/material';

/**
 * Resolves theme palette token paths (e.g. 'indigo.700') to concrete color
 * strings. Shared by the DBO usage detail page and the stacked bar chart so
 * entity colors stay consistent across the two surfaces.
 */
export const useResolveThemeColor = (): ((token: string) => string) => {
  const theme = useTheme();

  return useMemo(
    () =>
      (token: string): string => {
        const parts = token.split('.');
        let obj: Record<string, unknown> = theme.palette as never;
        for (const part of parts) {
          obj = (obj?.[part] ?? {}) as Record<string, unknown>;
        }
        return typeof obj === 'string' ? obj : token;
      },
    [theme.palette]
  );
};
